// extracted by mini-css-extract-plugin
export var alertIcon = "_qn-0";